import { render, staticRenderFns } from "./forgot_password.vue?vue&type=template&id=e13281ba&scoped=true"
import script from "./forgot_password.vue?vue&type=script&lang=js"
export * from "./forgot_password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13281ba",
  null
  
)

export default component.exports